import {
  WSCard,
  WSDataItem,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";

import { PayrollRunsWalletBalance } from "../../types";

type Props = {
  balance: PayrollRunsWalletBalance;
  onManageAccount?: () => void;
  onTopUp?: () => void;
};

export const WalletBalanceCard: React.FC<Props> = ({
  balance,
  onManageAccount,
  onTopUp
}) => (
  <WSCard
    actions={{
      alignment: "fill",
      buttons: [{ label: "Top-up wallet", kind: "Secondary", onClick: onTopUp }]
    }}
    divider="bottom"
    header={{
      label: "Available balance",
      value: {
        action: {
          label: `(•••${balance.accountMask})`,
          rightIcon: "chevron-right",
          onClick: onManageAccount
        }
      }
    }}
  >
    <WSText.Heading1 color="gray500" mb="XL" weight="book">
      {formatMoney(balance.availableBalance, Currency.USD)}
    </WSText.Heading1>

    <WSList gap="S">
      <WSDataItem
        inline
        label="Current balance"
        value={formatMoney(balance.currentBalance, Currency.USD)}
      />
      <WSDataItem
        inline
        label="Pending amounts"
        value={formatMoney(balance.pendingAmount, Currency.USD)}
      />
    </WSList>
  </WSCard>
);
